import PropTypes from 'prop-types';
import { Component } from 'react';
import { Alert, Button } from 'react-bootstrap';
import COLORS from '../../theme/colors';
import FOSSALogo from '../generic/FOSSAInlineSVG/FOSSALogo';
import Loader from '../generic/Loader';
import { window } from '../../globals';
import { get, put } from '../../redux/api';

class JoinOrganization extends Component<
  {
    location: any;
  },
  {
    error: any;
    loading: boolean;
    success: boolean;
    joining_organization: any;
  }
> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      loading: false,
      success: false,
      joining_organization: null,
    };
  }

  componentDidMount() {
    if (window.user && !window.user.organizationId) {
      const { queryInviteToken } = this;
      if (queryInviteToken) {
        this.onGetOrgFromInviteToken(queryInviteToken);
      } else {
        this.setState({ error: 'Invalid invite token.' });
      }
    }
  }

  get queryInviteToken(): string | undefined {
    // The "invite_token" is being phased out as it's renamed to "inviteToken".
    return this.props.location.query?.inviteToken || this.props.location.query?.invite_token;
  }

  onGetOrgFromInviteToken = async (token) => {
    try {
      const resp = await get(`/api/user/joinOrganization?invite_token=${token}`);
      this.setState({
        joining_organization: resp.data,
        loading: false,
      });
    } catch (err) {
      this.setState({ error: err.data || err, loading: false });
    }
  };

  onJoinOrganization = async () => {
    this.setState({ loading: true });
    try {
      await put(
        '/api/user/join-organization',
        { inviteToken: this.queryInviteToken },
      );

      this.setState({ success: true, loading: false });
    } catch (err) {
      this.setState({ error: err.data || err, loading: false });
    }
  };

  render() {
    if (this.state.loading) return <Loader />;
    if (!window.user)
      return (
        <Alert className="text-center" style={{ backgroundColor: COLORS.fossaRed }}>
          No user logged in.
        </Alert>
      );
    if (window.user && window.user.organizationId)
      return (
        <Alert className="text-center" style={{ backgroundColor: COLORS.fossaRed }}>
          User already belongs to an organization
        </Alert>
      );
    if (this.state.error)
      return (
        <Alert className="text-center" style={{ backgroundColor: COLORS.fossaRed }}>
          {this.state.error}
        </Alert>
      );
    if (!this.state.joining_organization)
      return (
        <Alert className="text-center" style={{ backgroundColor: COLORS.fossaRed }}>
          No organization was found.
        </Alert>
      );

    var org_title = this.state.joining_organization.title;
    if (this.state.success) {
      return (
        <div className="panel padded container text-center" style={{ marginTop: '40px' }}>
          <FOSSALogo
            color={COLORS.fossaSlateBlue}
            width={120}
          />
          <br />
          <br />
          <h1>
            You have successfully joined the "<b>{org_title}</b>" organization. Click <a href="/projects">here</a> to
            view projects.
          </h1>
        </div>
      );
    }
    return (
      <div className="panel padded container text-center" style={{ marginTop: '40px' }}>
        <FOSSALogo
          color={COLORS.fossaSlateBlue}
          width={120}
        />
        <br />
        <br />
        <h1>
          Click to join "<b>{org_title}</b>" organization
        </h1>
        <Button onClick={this.onJoinOrganization} className="btn btn-cta">
          Join {org_title}
        </Button>
      </div>
    );
  }
}

export default JoinOrganization;
